// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".qrCode[data-v-2d298e3a] {\n  width: 250px;\n  height: 250px;\n  display: inline-block;\n}\n.qrCode img[data-v-2d298e3a] {\n  width: 100%;\n  height: 100%;\n}\n.url[data-v-2d298e3a] {\n  font-size: 1.2em;\n  font-weight: bold;\n}\n\n/*.vvd{*/\n/*    >>> .v-dialog{*/\n/*        position: absolute;*/\n/*    }*/\n/*}*/", ""]);
// Exports
module.exports = exports;
